// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"_-_-record-it-components-src-button-FixedButtonContainerProvider-__buttonWrapper"};